const MailClientSettings = ({ data = {}, closePopup, updateError }) => {
    return (
        <div className="mjs-pp">
            <h2>Mail Client Settings</h2>
            <table className="mjs-table">
                <thead>
                    <tr>
                        <th colSpan={2}>Secure SSL/TLS Settings (Recommended)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Username:</td>
                        <td className="mjs-italics">Use email address</td>
                    </tr>
                    <tr>
                        <td>Password:</td>
                        <td className="mjs-italics">Use the email account's password</td>
                    </tr>
                    <tr>
                        <td>Incoming Server:</td>
                        <td>{data.cleanCurrSiteUrl} IMAP Port: 993</td>
                    </tr>
                    <tr>
                        <td>Outgoing Server:</td>
                        <td>{data.cleanCurrSiteUrl} SMTP Port: 465</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            IMAP, SMTP and POP3 require authentication.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default MailClientSettings;
